<form class="form"
      [formGroup]="textForm"
      (ngSubmit)="submit()">

  @if (defaults()?.url || loadingDefaults().length) {
    <span></span>
    <div>
      <span i18n>Loading defaults for <app-nav [url]="defaults()?.url || ('tag:/' + loadingDefaults()[0].tag)" /></span>
      @if (!defaults()) {
        <app-loading [inline]="true" />
      }
    </div>
  }
  @if (!advanced()) {
    @if (store.submit.wiki()) {
      <label for="title" i18n>Wiki:</label>
    } @else {
      <label for="title" i18n>Title:</label>
    }
    <div class="form-array">
      <input id="title"
             name="title"
             type="text"
             [formControl]="title"
             (blur)="validate($any($event.target))">
    </div>

    <app-select-plugin [picker]="true"
                       class="shrink"
                       [text]="true"
                       i18n-title title="Add Plugin"
                       (picked)="bookmarks.toggleTag($event)" />
    <app-form-plugins id="plugins"
                      (togglePlugin)="togglePlugin($event)"
                      [group]="textForm"
                      [values]="pluginValues()" />

    @if (customEditor()) {
      <span><!-- Editor --></span>
      <div class="fill-editor">
        <ngx-monaco-editor #ed
                           [formControl]="comment"
                           [options]="codeOptions()"
                           [style.height]="'min(200px, 90vh)'"
                                               appResizeHandle
                           [hitArea]="config.mobile() ? 48 : 20" />
      </div>
    } @else {
      @if (store.submit.wiki()) {
        <label [for]="ed.id()" class="editor-label" i18n>Entry:</label>
      } @else {
        <label [for]="ed.id()" class="editor-label" i18n>Comment:</label>
      }
      <div class="fill-editor">
        <app-editor #ed
                    class="bubble"
                    [control]="comment"
                    (syncEditor)="syncEditor()"
                    [tags]="tags"
                    (syncTags)="setTags($event)"
                    (addSource)="addSource($event)"
                    (uploadCompleted)="addCompletedUpload($event)"
                     [autoFocus]="true" />
      </div>
    }

    <app-tags #tagsFormComponent [group]="textForm" />

    <span><!-- Advanced --></span>
    <a class="fake-link no-select" (click)="showAdvanced()" i18n>show advanced</a>
  } @else {
    <app-ref-form [group]="textForm"
                  [ref]="savedRef()"
                  [creating]="true"
                  (toggleTag)="bookmarks.toggleTag($event)" />
  }

  @for (e of serverError(); track e) {
    <span><!-- Unexpected Error --></span>
    <div class="error">{{ e }}</div>
  }

  <span><!-- Buttons --></span>
  <span class="buttons right floating">
    @if (randomURL() && (addAnother || store.hotkey())) {
      <div class="add-more" i18n-title title="Will not clear form to all another Ref.">
        <input id="addAnother" type="checkbox" [checked]="addAnother" (input)="addAnother = !addAnother">
        <label for="addAnother" i18n>Add another</label>
      </div>
    }
    @if (submitting() || saving()) {
      <app-loading [inline]="true" />
    }
    @if (admin.getPlugin('plugin/editing')) {
      <button type="button" [disabled]="submitting() || saving() || submitted() || textFormPristine()" (click)="saveForLater(true)" i18n>Save for later</button>
    }
    <button type="submit" [disabled]="submitting() || submitted() && !textFormValid()" i18n>Submit</button>
  </span>
</form>
